import { render, staticRenderFns } from "./QueryAnalysisDocList.vue?vue&type=template&id=4bdf5a48&scoped=true"
import script from "./QueryAnalysisDocList.vue?vue&type=script&lang=js"
export * from "./QueryAnalysisDocList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf5a48",
  null
  
)

export default component.exports